module.exports = __webpack_public_path__ + "img/vip_level_5.95a7f0a1.png";